
<div class="control-section drag">
  <ejs-dialog #modalphoihop [buttons]='dlgButtons' [position]='position' [visible]='false' [header]='modalTitle' [animationSettings]='animationSettings'
              [resizeHandles]='resizeHandleDirection' [enableResize]='dialogResize' [allowDragging]='dialogdragging'
              [target]='target'
              [showCloseIcon]='false' [width]='width' (open)="dialogOpen()" (close)="dialogClose()">
    <app-tonghop-donvithanhphanedit #ctdonviphoihopedit (savect)="savept($event)"></app-tonghop-donvithanhphanedit>
    <ng-template #footerTemplate>
    </ng-template>
  </ejs-dialog>
</div>


<div class="row">
  
  <div style="width:100%;float:left;margin-left:2px">
    <div class="row">
      <label class="control-label col-2">Nội dung <span style="color:red">&nbsp;(*)</span></label>
      <div class="col-10">
        <textarea type="text" tabindex="10" rows="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Noi_Dung"></textarea>
      </div>
    </div>
    <div class="row">
      <label class="control-label col-2">Ngày <span style="color:red">&nbsp;(*)</span></label>
      <div class="col-2">
        <ejs-datepicker [format]="format" [enableMask]="enableMaskSupport" [(value)]='doituongSelect.Ngay_BD'></ejs-datepicker>
      </div>
      <div class="col-1">Từ giờ</div>
      <div class="col-2">
        <ejs-timepicker [format]="'HH:mm'" [enableMask]="true" [(value)]='doituongSelect.Ngay_BD'></ejs-timepicker>
      </div>
      <div class="col-2">
        <ejs-timepicker [format]="'HH:mm'" [enableMask]="true" [(value)]='doituongSelect.Ngay_KT'></ejs-timepicker>
      </div>
    </div>
    <div class="row">
      <label class="control-label col-2">Địa điểm</label>
      <div class="col-10">
        <ng-select #slNoiGui
                   labelForId="99"
                   class="twcol"
                   [tabIndex]="5"
                   [openOnEnter]="false"
                   [items]="inputphonghops"
                   bindValue="ID"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn_Ten"
                   [(ngModel)]="doituongSelect.Phong_Hop">
          <ng-template ng-footer-tmp *ngIf="quyen_themdonvingoai===true">
            <a (click)="addDonVi()"><em class="mr-2 far fa-plus-square"></em>Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="row">
      <div class="col-11">
        <div class="row">
          <label class="control-label col-2">Chủ trì</label>
          <div class="col-10" style="padding-left:30px">
            <textarea type="text" tabindex="10" rows="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Chu_Tri"></textarea>
          </div>
        </div>
        <div class="row">
          <label class="control-label col-2">Chuẩn bị</label>
          <div class="col-10"  style="padding-left:30px">
            <textarea type="text" tabindex="10" rows="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Chuan_Bi"></textarea>
          </div>
        </div>
        <div class="row">
          <label class="control-label col-2">Thành phần</label>
          <div class="col-10"  style="padding-left:30px">
            <textarea type="text" tabindex="10" rows="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Thanh_Phan"></textarea>
          </div>
          
        </div>
      </div>
      <div class="col-1">
        <a (click)="chondonvi('1')"><span class="css_btn_nn" style="height:100px;width:98%;align-items:center">Thành phần</span></a>
      </div>
    </div>
    

    <div class="row">
      <label class="control-label col-2">Số người tham dự</label>
      <div class="col-2">
        <input class="form-control"
               maxlength="20"
               currencyMask
               [(ngModel)]="doituongSelect.So_Nguoi"
               name="value"
               [placeholder]="'Số người tham dự'"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
      <label class="control-label col-2">Tình trạng</label>
      <div class="col-2">
        <ng-select #slNoiGui
                   labelForId="99"
                   class="twcol"
                   [tabIndex]="6"
                   [openOnEnter]="false"
                   [items]="inputstatuss"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.Trang_Thai"
                   (change)="onDoiTuongChange($event)">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>

          </ng-template>
        </ng-select>

      </div>

    </div>

    <div class="row">
      <label class="control-label col-2">Duyệt lịch</label>
      <div class="col-4">
        <div class="checkbox c-checkbox">
          <label style="vertical-align:middle">
            <input tabIndex="5" type="checkbox" [(ngModel)]="doituongSelect.Duyet" />
            <span class="fa fa-check"></span> 
          </label>
        </div>
      </div>
      
    </div>
    <div class="row">
      <div class="col-2">
        <div class="uploadtemplate">
          <div id='dropArea'>
            <span id='drop' class="droparea"> <a id='browse'><u>Chọn file</u></a> </span>
            <ejs-uploader #defaultupload id='defaultfileupload' [asyncSettings]='path'
                          [dropArea]='dropElement' (removing)='onFileRemove($event)' [files]='preLoadFiles'
                          (uploading)="onFileUpload($event)" title="Chọn file"
                          [allowedExtensions]='allowExtensions' (selected)='onSelected($event)'
                          (success)='onSuccess($event)'></ejs-uploader>
          </div>
        </div>
      </div>
      <!--<label class="control-label col-2">

      <ejs-uploader #defaultupload id='defaultfileupload' [asyncSettings]='path'
                    [dropArea]='dropElement' (removing)='onFileRemove($event)' [files]='preLoadFiles'
                    (uploading)="addHeaders($event)" title="Chọn file"
                    [allowedExtensions]='allowExtensions' (selected)='onSelected($event)'
                    (success)='onSuccess($event)'></ejs-uploader>
    </label>-->
      <div class="col-10">
        <div class="lbl" style=" float:left; width:84%; height:auto;border-style:none">
          <div id="lblFile">
            <div class="row" *ngFor="let u of doituongSelect.Files">
              <div class="col-11" style="float:left">
                <img src="{{u.icon}}" border="0" width="13" height="13"><a href="{{u.File_Path}}" return="" false="" tabindex="0" target="_blank">{{u.file_name}}</a>
              </div>
              <div class="col-1 css_btn_delete"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <label class="control-label col-2"></label>
      <div class="col-6">
        
      </div>
      <div class="col-4">
        <button class="mb-1 mr-1 btn btn-primary" href="#" (click)="savelich(0)">
          <!--<i class="fa-2x mr-2 fas fa-save"></i>-->
          Lưu lại
        </button>
        <button class="mb-1 mr-1 btn btn-danger" href="#" (click)="closeModal()">
          <!--<i class="fa-2x mr-2 far fa-window-close"></i>-->
          Thoát
        </button>
      </div>
    </div>


    <!--<div class="row" style="color:black">
    <div class="col-6"></div>

  </div>-->

  </div>
 
</div>


<!--<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>

  </div>
  

</div>-->


<!--<modal #modaldonvi [cssClass]="'modal7'" [backdrop]="'static'">
  <modal-header [show-close]="true">
    <h4 class="modal-title">{{modalTitle}}</h4>
  </modal-header>
  <modal-body>
    <app-quantri-donviedit #dtedonvi (save)="saveDonVi($event)"></app-quantri-donviedit>
  </modal-body>
</modal>-->


<!--<modal #modaldonviphoihop [cssClass]="'modal600'" [backdrop]="'static'">
  <modal-header [show-close]="false">
    <h4 class="modal-title">Chọn</h4>
  </modal-header>
  <modal-body>
    <app-danhmuc-donviphoihopedit #dtdonviphoihop (save)="saveModalDV($event)"></app-danhmuc-donviphoihopedit>
  </modal-body>
</modal>-->


<!--<modal #modalphucdapcongvan [cssClass]="'modalsanpham800'" [backdrop]="'static'">
  <modal-header [show-close]="false">
    <h4 class="modal-title">Phúc đáp công văn</h4>
  </modal-header>
  <modal-body>
    <app-tuychon-phucdapcongvanedit #ctphucdapcongvanedit (savect)="saveBienPhapNV($event)"></app-tuychon-phucdapcongvanedit>
  </modal-body>
</modal>-->

<!--<modal #modalBZDinhKem [cssClass]="'modal800'" [backdrop]="'static'">
  <modal-header [show-close]="true">
    <h4 class="modal-title">Đính kèm</h4>
  </modal-header>
  <modal-body>
    <app-tonghop-dinhkemedit #dteBZDinhKem (savect)="savedk($event)"></app-tonghop-dinhkemedit>
  </modal-body>
</modal>-->
